import { Route } from "found";
import React from "react";

import Share from "./screens/Share";

export const routes = <Route path="/partage" Component={Share} />;
